import AddIcon from "@mui/icons-material/Add";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import {
  Box,
  Button,
  Container,
  Link,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";

import Loading from "../../components/loading/loading";
import { homeStyle } from "../../styles/container/home";
import { DeleteRoleForm, RoleForm } from "./Component";
import useViewModel from "./ViewModel";

interface SelectedData {
  name: string;
  id: string;
}

interface DialogState {
  roleForm: boolean;
  deleteRoleForm: boolean;
}

function MasterRoleRevamped() {
  const {
    data: { listRolesName, roleDetail, loadingActive },
    method: {
      onGetListRolesName,
      onGetRoleDetail,
      onChangeFormValue,
      onCreateNewRole,
      onEditRole,
      onDeleteRole,
    },
  } = useViewModel();
  const [actionType, setActionType] = useState<"CREATE" | "EDIT">("CREATE");
  const [deleteType, setDeleteType] = useState<"SINGLE" | "BULK">("SINGLE");
  const [selectedData, setSelectedData] = useState<SelectedData>({
    id: "",
    name: "",
  });
  const [dialogState, setDialogState] = useState<DialogState>({
    deleteRoleForm: false,
    roleForm: false,
  });
  const [searchText, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  useEffect(() => {
    onGetListRolesName();
  }, []);

  const isSmallScreen = useMediaQuery("(min-width: 600px)");

  const columns: GridColDef[] = [
    {
      headerAlign: "center",
      align: "center",
      field: "action",
      width: isSmallScreen ? 95 : 120,
      renderHeader: () => <b>Action</b>,
      renderCell: (params) => (
        <div
          style={{ display: "flex", flexDirection: "row", cursor: "pointer" }}
        >
          <Link
            onClick={(e) => {
              e.stopPropagation();
              setActionType("EDIT");
              setSelectedData({
                name: params.row.roleName,
                id: params.row.roleID,
              });
              onGetRoleDetail(params.row.roleName, params.row.roleID);
              setDialogState((prev) => ({ ...prev, roleForm: true }));
            }}
          >
            <EditOutlinedIcon className="pencilAction" />
          </Link>
          {params.row.isActive === false && (
            <Link
              onClick={() => {
                setDeleteType("SINGLE");
                setSelectedData({
                  name: params.row.roleName,
                  id: params.row.roleID,
                });
                setDialogState((prev) => ({ ...prev, deleteRoleForm: true }));
              }}
            >
              <DeleteOutlinedIcon className="black" />
            </Link>
          )}
        </div>
      ),
    },
    {
      field: "roleName",
      headerAlign: "left",
      width: isSmallScreen ? 790 : 150,
      renderHeader: () => <b>Role Name</b>,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {params.row.roleName}
        </div>
      ),
    },
  ];

  return (
    <Container maxWidth={false} disableGutters sx={homeStyle.containerStyling}>
      <Box sx={{ fontSize: "25px" }} className="black">
        Role Management
        <hr />
      </Box>
      <br />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          marginBottom: "10px",
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            setActionType("CREATE");
            setSelectedData({ name: "", id: "" });
            onGetRoleDetail();
            setDialogState((prev) => ({ ...prev, roleForm: true }));
          }}
          sx={{ marginBottom: "10px", textTransform: "none" }}
        >
          <AddIcon /> Add New Role
        </Button>
        <div className="searchDataTable">
          <TextField
            placeholder="Search"
            variant="outlined"
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onGetListRolesName(searchText);
              }
            }}
          />
          <Button
            onClick={() => {
              onGetListRolesName(searchText);
            }}
            style={{ padding: 0, minWidth: "40px" }}
          >
            <SearchOutlinedIcon className="black" />
          </Button>
        </div>
      </Box>

      {selectedRows.length > 0 && (
        <Button
          variant="contained"
          sx={homeStyle.buttonDeleteStyle}
          onClick={() => {
            setDeleteType("BULK");
            setDialogState((prev) => ({ ...prev, deleteRoleForm: true }));
          }}
        >
          <span> </span>
          <DeleteOutlinedIcon />
        </Button>
      )}
      <div style={{ width: "100%", backgroundColor: "white" }}>
        <DataGrid
          rows={listRolesName}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          getRowId={(row) => row.roleID}
          pageSizeOptions={[5, 10]}
          checkboxSelection
          onRowSelectionModelChange={(row) => setSelectedRows(row as string[])}
          isRowSelectable={(params) => params.row.isActive === false}
          autoHeight
          getRowHeight={() => "auto"}
        />
      </div>
      <RoleForm
        handleDialogClose={() => {
          setDialogState((prev) => ({ ...prev, roleForm: false }));
        }}
        handleDialogSave={() =>
          actionType === "CREATE"
            ? onCreateNewRole(roleDetail)
            : onEditRole(selectedData, roleDetail)
        }
        openDialog={dialogState.roleForm}
        defaultValue={roleDetail}
        onChangeValue={onChangeFormValue}
      />
      <DeleteRoleForm
        openDialog={dialogState.deleteRoleForm}
        handleDialogClose={() =>
          setDialogState((prev) => ({ ...prev, deleteRoleForm: false }))
        }
        handleDialogDelete={() => {
          onDeleteRole(
            deleteType === "SINGLE" ? [selectedData.id] : selectedRows
          );
        }}
      />
      <Loading open={loadingActive} />
    </Container>
  );
}

export default MasterRoleRevamped;
